module.exports = (href) => {
  const splitHref = href.split('/');

  return splitHref[splitHref.length - 2].replace(/\-/g, '_');
};




// WEBPACK FOOTER //
// ./src/pages/helpers/getPageNameFromLocation.js